<template>
    <img v-if="avatar" :src="userAvatarSrc" class="avatar"/>
    <svg-icon v-else :symbol="avatarIcon" class="avatar"></svg-icon>
</template>

<script>
    import avatarIcon from '../../icons/icon-avatar.svg-sprite'
    import SvgIcon from './SvgIcon.vue'

    export default {

        props: ['avatar', 'default'],

        data() {
            return {
                avatarIcon
            }

        },

        computed: {
            userAvatarSrc: function () {
                return this.avatar ? _.get(this.avatar, 'sizes.icon.full_url') : this.default
            },
        },

        components: { SvgIcon }
    }
</script>

<style lang="scss" scoped>
    .avatar {
        display: inline-block;
        overflow: hidden;
        border-radius: 50%;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Avatar.vue